import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import FooterNav from "./FooterNav";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Marquee from "react-fast-marquee";
import SliderComponent from "./SliderComponent";
import Cookies from "js-cookie";
import { unsetCookie } from "./Login";
import Models from "./Wallet/Component/Models";
import { useDispatch, useSelector } from "react-redux";
import { setOpen, toggleOpen } from "../redux/slices/alertOpen";
import axios from "axios";

const HomePage = () => {
  const openalert = useSelector((state) => state.openAlert);
  const history = useNavigate();
  const [data, setData] = useState([]);
  const [notification, setNotification] = useState("");
  const [whats, setWhats] = useState("");
  const [tali, setTali] = useState("");
  const [selectedTab, setSelectedTab] = useState("lottery");
  const dispatch = useDispatch();
  const handleOpen = () => {
    dispatch(setOpen(true)); // Sets state to true
  };
  const handleClose = () => dispatch(toggleOpen());
  const token = Cookies.get("auth");
  const handleNavigation = (path) => {
    history(path);
  };

  const getUserData = async (uid) => {
    try {
      const response = await axios.get(
        `https://taskapi.demovt360.xyz/sst/src/api/planbuylist.php?userid=${uid}`,
        {
          headers: {
            Accept: "application/json", // Ensure the response is in JSON format
          },
          responseType: "json", // Treat the response as JSON
        }
      );

      if (response.status === 200) {
        // console.log("Success:", response);
        setData(response.data.plans);
        setWhats(response.data.whatsapp);
        setTali(response.data.teligram);
        setNotification(response.data.notification);
        // You can set the data here, for example: setData(response.data);
      } else {
        alert("Request failed with status: " + response.status);
      }
    } catch (error) {
      console.error("Error during request:", error);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("mamberId");
    if (!token) {
      history("/login");
    } else {
      getUserData(token);
    }
  }, []);

  const handleTabClick = (tabId) => {
    setSelectedTab(tabId);
  };

  const logOut = () => {
    unsetCookie();
  };

  const handleClick = (item) => {
    history(`/profit`);
  };

  return (
    <>
      <div
        style={{
          marginBottom: "60px",
          width: "100%",
          // background:
          //   "linear-gradient(to right, #DECBA4, #3E5151)",
        }}
      >
        {/* <Models handleClose={handleClose} open={openalert} /> */}
        <Box>
          <AppBar
            position="static"
            style={{
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              padding: "2px 10px",
              height: "3.22667rem",
              boxShadow: "unset",
              background: "#3d3b6f",
            }}
          >
            <Typography style={{ color: "#fff", fontSize: 26 }}>
              Company
            </Typography>
            {/* <Box
              style={{ borderColor: "#fff", color: "#fff" }}
              onClick={logOut}
            >
              <Typography>language</Typography>
            </Box> */}
          </AppBar>
        </Box>
        {/*Slider   */}
        <SliderComponent />

        <Box
          margin="5px"
          marginTop="-55px"
          display="flex"
          alignItems="center"
          p="10px"
          border="1px solid #ddd"
          borderRadius="8px"
          style={{ backgroundColor: "#fff", position: "relative", zIndex: 10 }}
        >
          <img src="images/home_notice.png" width="25px" height="25px" />
          <Box flex={1}>
            <Marquee speed={20}>
              <Typography variant="subtitle1" color="#333">
                Congratulations to **4524**: Invited a friend to become VIP1 and
                received2800₦.
              </Typography>
            </Marquee>
          </Box>
        </Box>

        <div
          style={{
            display: "flex",
            marginTop:"15px",
            flexDirection: "row",
            margin: "10px",
            // marginBottom: "0px",
            // backgroundColor: "darkblue",
          }}
        >
          
          <div
            style={{
              width: "100%",
              // backgroundColor: "yellow",
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              gap: "5px",
              // marginLeft: "17px",
              // marginRight: "4px",
            }}
          >
            {/* <div className=""> */}
            {[
              {
                href: "/recharge",
                imgSrc: "images/recharge.png",
                title: "Recharge",
              },
              {
                href: "/withdrawal",
                imgSrc: "images/withdraw.png",
                title: "Withdrawal",
              },
            ].map((game, index) => (
              <Box
                key={index}
                style={{
                  height: "35px",
                  padding: "12px",
                  display: "flex",
                  width: "42%",
                  // gap:"5px",
                  borderRadius: "5px",
                  // justifyContent: "space-between",
                  alignItems: "center",
                  flexDirection: "row",
                  backgroundSize: "100% 100%",
                  marginBottom: "5px",
                  background: "#fff",
                  boxShadow:
                    "0 -.05333rem .13333rem #fff6f4 inset, 0 .10667rem .21333rem .05333rem #d0d0ed5c",
                  textDecoration: "none",
                }}
                onClick={() => history(game.href)}
              >
                <div style={{ width: "50%" }}>
                  <img
                    style={{ width: "80%", height: "80%" }}
                    src={game.imgSrc}
                    alt={game.title}
                  />
                </div>
                <div>
                  <Typography style={{ fontSize: "16px", color: "#333" }}>
                    {game.title}
                  </Typography>

                  {/* <Typography style={{ fontSize: "12px", color: "#fff" }}>
                      {game.description2}
                    </Typography> */}
                </div>
              </Box>
            ))}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            margin: "10px",
            marginBottom: "0p",
            // backgroundColor: "darkblue",
          }}
        >
          
          <div
            style={{
              width: "100%",
              // backgroundColor: "yellow",
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              gap: "5px",
              // marginLeft: "17px",
              // marginRight: "4px",
            }}
          >
            {/* <div className=""> */}
            {[
              {
                href: "/dailystatemant",
                imgSrc: "images/tag1.png",
                title: "Promotion Rewards",
              },
              {
                href: "/activity",
                imgSrc: "images/tag2.png",
                title: "VIP area",
              },
            ].map((game, index) => (
              <Box
                key={index}
                style={{
                  height: "35px",
                  padding: "12px",
                  display: "flex",
                  width: "42%",
                  // gap:"5px",
                  borderRadius: "5px",
                  // justifyContent: "space-between",
                  alignItems: "center",
                  flexDirection: "row",
                  backgroundSize: "100% 100%",
                  marginBottom: "5px",
                  background: "#fff",
                  boxShadow:
                    "0 -.05333rem .13333rem #fff6f4 inset, 0 .10667rem .21333rem .05333rem #d0d0ed5c",
                  textDecoration: "none",
                }}
                onClick={() => history(game.href)}
              >
                <div style={{ width: "50%" }}>
                  <img
                    style={{ width: "80%", height: "80%" }}
                    src={game.imgSrc}
                    alt={game.title}
                  />
                </div>
                <div>
                  <Typography style={{ fontSize: "16px", color: "#333" }}>
                    {game.title}
                  </Typography>

                  {/* <Typography style={{ fontSize: "12px", color: "#fff" }}>
                      {game.description2}
                    </Typography> */}
                </div>
              </Box>
            ))}
          </div>
        </div>
        {/* <Grid
          container
          sx={{
            display: "flex",
            padding: "5px",
            paddingTop: "9px",
            // margin:"px",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "14px",
          }}
        >
          {[
            { label: "Recharge", icon: "recharge.png", route: "/recharge" },
            { label: "Withdraw", icon: "withdraw.png", route: "/withdrawal" },
            { label: "Charity", icon: "Rg.png", route: "/charity" },
            { label: "Telegram", icon: "tali2.png", route: tali },
            { label: "Whatsapp", icon: "R.png", route: whats },
          ].map((item, index) => (
            <Grid
              item
              key={index}
              // onClick={() => item.route && handleNavigation(item.route)}
              onClick={() => {
                if (item.route) {
                  // Check if route is for Telegram or WhatsApp
                  if (item.route === tali || item.route === whats) {
                    window.open(item.route, "_blank"); // Open in a new tab
                  } else {
                    handleNavigation(item.route); // Regular navigation within the app
                  }
                }
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  cursor: item.route ? "pointer" : "default",
                  "&:hover": {
                    transform: "scale(1.05)",
                    transition: "0.3s ease-in-out",
                  },
                }}
              >
                <Box
                  sx={{
                    height: "3.5rem",
                    width: "3.5rem",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    // background: "linear-gradient(135deg, #ffffff, #f0f0f0)",
                    borderRadius: "10rem",
                    // background: "#fff",
                    // boxShadow: "4px 4px 15px rgba(0,0,0,0.2)",
                  }}
                >
                  <img
                    width={55}
                    // height={55}
                    src={`/images/${item.icon}`}
                    alt={item.label}
                    // style={{  borderRadius: "10rem",}}
                  />
                </Box>
                <Typography
                  mt={1}
                  variant="subtitle1"
                  sx={{ color: "#fff", lineHeight: 1 }}
                >
                  {item.label}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid> */}
        <div onClick={() => history('/share')}>

        <img src="images/bac1.png" width="100%" alt="img" />
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "5px",
            minWidth: "165px",
            margin: "10px",
          }}
        >
          <Box
            style={{
              width: "100%",
              display: "flex",
              // flexWrap: "wrap",
              // justifyContent: "center",
              // alignItems: "center",
            }}
          >
            <Typography
              variant="subtitle2"
              style={{ color: "#d05e1b", marginLeft: "17px" }}
            >
              Task Hall
            </Typography>
          </Box>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              // backgroundColor: "darkblue",
            }}
          >
            <div
              style={{
                width: "100%",
                // backgroundColor: "yellow",
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                gap: "5px",
                // marginLeft: "17px",
                // marginRight: "4px",
              }}
            >
              {/* <div className=""> */}
              {[
                {
                  href: "/task",
                  imgSrc: "images/ins.png",
                  title: "Instagram",
                  description1: "Watch and give your rating",
                  // description2: "Green/Red/Purple to win",
                },
                {
                  href: "/task",
                  imgSrc: "images/fac.png",
                  title: "Facebook",
                  description1: "Watch and give your rating",
                  // description2: "Green/Red/Purple to win",
                },
                {
                  href: "/task",
                  imgSrc: "images/tic.png",
                  title: "Tictoc",
                  description1: "Watch and give your rating",
                  // description2: "Big/Small/Odd/Even",
                },
                {
                  href: "/task",
                  imgSrc: "images/you.png",
                  title: "Youtube",
                  description1: "Watch and give your rating",
                  // description2: "Big/Small/Odd/Even",
                },
              ].map((game, index) => (
                <Box
                  key={index}
                  style={{
                    height: "55px",
                    padding: "12px",
                    display: "flex",
                    width: "42%",
                    borderRadius: "0.5rem",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexDirection: "row",
                    backgroundSize: "100% 100%",
                    marginBottom: "1.17333rem",
                    background:"#475358",
                    boxShadow:
                      "0 -.05333rem .13333rem #fff6f4 inset, 0 .10667rem .21333rem .05333rem #d0d0ed5c",
                    textDecoration: "none",
                  }}
                  onClick={() => history(game.href)}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "1px",
                    }}
                  >
                    <div>
                      <Typography style={{ fontSize: "20px", color: "#fff" }}>
                        {game.title}
                      </Typography>

                      {/* <Typography style={{ fontSize: "12px", color: "#fff" }}>
                      {game.description2}
                    </Typography> */}
                    </div>
                    <Typography style={{ fontSize: "14px", color: "#fff" }}>
                      {game.description1}
                    </Typography>
                  </div>
                  <img
                    style={{ width: "70%", height: "80%" }}
                    src={game.imgSrc}
                    alt={game.title}
                  />
                </Box>
              ))}
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              margin: "5px",
              // backgroundColor: "darkblue",
            }}
          >
            <div
              style={{
                width: "100%",
                // backgroundColor: "yellow",
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                gap: "5px",
                // marginLeft: "17px",
                // marginRight: "4px",
              }}
            >
              {/* <div className=""> */}
              {[
                {
                  href: "/about",
                  imgSrc: "images/tag1.png",
                  title: "Company Profile",
                },
                {
                  href: "/ehbook",
                  imgSrc: "images/tag2.png",
                  title: "Company philosophy",
                },
              ].map((game, index) => (
                <Box
                  key={index}
                  style={{
                    height: "35px",
                    padding: "12px",
                    display: "flex",
                    width: "42%",
                    // gap:"5px",
                    borderRadius: "5px",
                    // justifyContent: "space-between",
                    alignItems: "center",
                    flexDirection: "row",
                    backgroundSize: "100% 100%",
                    marginBottom: "1.17333rem",
                    background: "#fff",
                    boxShadow:
                      "0 -.05333rem .13333rem #fff6f4 inset, 0 .10667rem .21333rem .05333rem #d0d0ed5c",
                    textDecoration: "none",
                  }}
                  onClick={() => history(game.href)}
                >
                  <div style={{ width: "50%" }}>
                    <img
                      style={{ width: "80%", height: "80%" }}
                      src={game.imgSrc}
                      alt={game.title}
                    />
                  </div>
                  <div>
                    <Typography style={{ fontSize: "16px", color: "#333" }}>
                      {game.title}
                    </Typography>

                    {/* <Typography style={{ fontSize: "12px", color: "#fff" }}>
                      {game.description2}
                    </Typography> */}
                  </div>
                </Box>
              ))}
            </div>
          </div>
        </div>
        {/* <img src="/images/profit222.jpg" width="100%" alt="img" /> */}
        {/* <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "13px",
            minWidth: "165px",
          }}
        >
          {[
            "BRABUS",
            "BRABUS1",
            "BRABUS3",
            "BRABUS4",
        
          ].map((item, ind) => {
            return (
              <div
                key={ind}
                onClick={() => handleClick(item)}
                style={{
                  display: "flex",
                  // flexDirection: "column",
                  position: "relative",
                  width: "100%",
                  margin: "0 10px",
                  // minWidth: "165px",
                  alignItems: "center",
                  background: "linear-gradient(135deg, #f8f9fa, #e9ecef)",
                  borderRadius: "8px",
                  fontSize: "12px",
                  color: "#333",
                  overflow: "hidden",
                  boxShadow:
                    "4px 4px 10px rgb(227 196 196 / 8%), -4px -4px 10px rgb(97 33 33 / 60%)",
                  transition: "all 0.3s ease-in-out",
                  border: "1px solid rgba(0, 0, 0, 0.05)",
                }}
              >
                <img
                  src="/images/newd.jpg"
                  draggable="false"
                  width={"50%"}
                  height={"120px"}
                />

                <Box
                  sx={{
                    // background: "linear-gradient(135deg, #f8f9fa, #e9ecef)",
                    textAlign: "center",
                    width: "50%",
                    height: "100%",
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{ color: "#828282", fontWeight: "bold" }}
                  >
                    BRABUS
                  </Typography>
                  <Typography sx={{ color: "#666", mb: 1, fontSize: "16px" }}>
                    Commission: <strong>12.00</strong>
                  </Typography>
                  <Button
                    sx={{
                      px: 2,
                      // py: 1,
                      mb: 1,
                      background: "#f83600",
                      color: "#fff",
                      borderRadius: "20px",
                      fontSize: "14px",
                      fontWeight: "bold",
                      lineHeight: 1,
                      textTransform: "none",
                      transition: "all 0.3s ease-in-out",
                      "&:hover": {
                        background:
                          "linear-gradient(to right, rgb(74, 64, 44), rgb(62, 81, 81))",
                      },
                    }}
                  >
                    Rating Now
                  </Button>
                </Box>
              </div>
            );
          })}
        </div> */}
      </div>
      {/* <Box style={{ marginTop: "60px" }}> */}
      <FooterNav />
      {/* </Box> */}
    </>
  );
};
export default HomePage;
